module.exports = __webpack_public_path__ + "img/explain.2a4e9b11.png";